export default {
  amount: "Montant",
  successPendingVerification: "Paiement en attente de vérification",
  successHeading: "Paiement réussi",
  transaction: "Transaction",
  invoice: "Facture",
  transactionTime: "Heure de la transaction",
  cannotFetchPaymentTransaction:
    "Une erreur est survenue lors de la récupération de votre transaction de paiement. Veuillez réessayer plus tard.",
  paymentReceived: "Paiement reçu",
  invoicePaidInFull: "La facture {{number}} est payée en totalité.",
  invoicePartialPayment: "Paiement partiel reçu pour la facture {{number}}.",
  paidToVendorOn: "Payé à {{vendor}} le {{date}}",
  receiptNumber: "Numéro de reçu",
  datePaid: "Date de paiement",
  amountPaid: "Montant payé",
  payBalance: "Payer le solde",
  downloadReceipt: "Télécharger le reçu",
  questions: "Des questions ?",
  contactVendor: "Contacter {{vendor}}",
  processingTitle: "Traitement de votre paiement",
  chargingAmount: "Débit de {{amount}}",
  keepWindowOpen:
    "Sécurisé et chiffré — veuillez garder cette fenêtre ouverte.",
};
